import { useContext } from "react";
import { Container, Flex, Heading, Text } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";
import "./login-page-about-section.css";

export function LoginPageAboutSection(): JSX.Element {
  const i18n = useContext(I18nContext);

  if (!i18n) {
    throw new Error("LoginPageAboutSection must be used within an I18nContext.Provider");
  }

  const { t } = i18n;

  return (
    <Flex direction="vertical">
      <Flex justify="center" align="center" style={{ width: "100%", background: "#FFFFFF" }}>
        <Heading
          size="primary"
          style={{
            fontSize: "4rem",
            width: "50%",
            textAlign: "center",
            lineHeight: "1",
            margin: "5rem 0",
            fontWeight: "200"
          }}
        >
          {t("auth.login.login-partner-base.choose-program-for-business", { ns: "spaces-dash-app-partners-login" })}
        </Heading>
      </Flex>
      <Container style={{ boxShadow: "none", paddingTop: "0px" }}>
        <Flex gap={32} className="partners-about-section-container">
          <Container.Well className="partners-about-section-wells">
            <Flex direction="vertical" gap={16} className="partners-about-section-boxes">
              <Heading>{t("auth.login.login-partner-base.channel-partner-text", { ns: "spaces-dash-app-partners-login" })}</Heading>
              <Text>{t("auth.login.login-partner-base.channel-partner-text-info", { ns: "spaces-dash-app-partners-login" })}</Text>
            </Flex>
          </Container.Well>
          <Container.Well className="partners-about-section-wells">
            <Flex direction="vertical" gap={16} className="partners-about-section-boxes">
              <Heading>{t("auth.login.login-partner-base.application-provider", { ns: "spaces-dash-app-partners-login" })}</Heading>
              <Text>{t("auth.login.login-partner-base.out-of-box-applications", { ns: "spaces-dash-app-partners-login" })}</Text>
            </Flex>
          </Container.Well>
          <Container.Well className="partners-about-section-wells">
            <Flex direction="vertical" gap={16} className="partners-about-section-boxes">
              <Heading>{t("auth.login.login-partner-base.solution-provider", { ns: "spaces-dash-app-partners-login" })}</Heading>
              <Text>{t("auth.login.login-partner-base.custom-solution-for-customer", { ns: "spaces-dash-app-partners-login" })}</Text>
            </Flex>
          </Container.Well>
          <Container.Well className="partners-about-section-wells">
            <Flex direction="vertical" gap={16} className="partners-about-section-boxes">
              <Heading>{t("auth.login.login-partner-base.enterprise-saas-platform", { ns: "spaces-dash-app-partners-login" })}</Heading>
              <Text>{t("auth.login.login-partner-base.crm-marketing-cloud-text", { ns: "spaces-dash-app-partners-login" })}</Text>
            </Flex>
          </Container.Well>
          <Container.Well className="partners-about-section-wells">
            <Flex direction="vertical" gap={16} className="partners-about-section-boxes">
              <Heading>{t("auth.login.login-partner-base.data-platform-text", { ns: "spaces-dash-app-partners-login" })}</Heading>
              <Text>{t("auth.login.login-partner-base.analyze-customer-data-text", { ns: "spaces-dash-app-partners-login" })}</Text>
            </Flex>
          </Container.Well>
          <Container.Well className="partners-about-section-wells">
            <Flex direction="vertical" gap={16} className="partners-about-section-boxes">
              <Heading>{t("auth.login.login-partner-base.hardware-partner", { ns: "spaces-dash-app-partners-login" })}</Heading>
              <Text>{t("auth.login.login-partner-base.sensors-hardware-devices-cisco-spaces-certified", { ns: "spaces-dash-app-partners-login" })}</Text>
            </Flex>
          </Container.Well>
        </Flex>
      </Container>
    </Flex>
  );
}
